import BookmarkButton from 'wishlists/components/Bookmark/Buttons/BookmarkButton'
import ExperienceBookmarkButton from 'wishlists/components/Bookmark/Buttons/Experience/ExperienceBookmarkButton'
import HotelBookmarkButton from 'wishlists/components/Bookmark/Buttons/HotelBookmarkButton'
import TourBookmarkButton from 'wishlists/components/Bookmark/Buttons/TourBookmarkButton'

export {
  HotelBookmarkButton,
  TourBookmarkButton,
  ExperienceBookmarkButton,
}

export default BookmarkButton
